import moment from 'moment'
import { sortObjectArrayByKey, isEmpty } from './generalUtils'
import { googleMapInit } from '../services/googleMapService'
const timeMargin = 15
const timeFormat = 'HH:mm'

/** ************ ROUTE HANDLING ********** **/
export const filterRoutePropertyByState = (routeStops, propertyState) => {
  return routeStops.filter(stop => stop.state !== propertyState)
}

export const propertyInRouteCheckByState = (
  clientRoutes,
  propertyState,
  propertyId
) => {
  let isPresent = false
  clientRoutes.forEach(route => {
    if (route.routeStops) {
      route.routeStops.forEach(stop => {
        if (stop.propertyId === propertyId && stop.state === propertyState) {
          isPresent = true
        }
      })
    }
  })
  return isPresent
}

/**
 *
 * @param {Array} clientRoutes
 * @param {String} propertyState
 *
 * Get property id list that are included in any of the client routes
 */
export const routePropertiesIdByState = (clientRoutes, propertyState) => {
  let propertyArray = []
  clientRoutes.forEach(route => {
    if (route.routeStops) {
      route.routeStops.forEach(stop => {
        if (
          stop.state === propertyState &&
          !propertyArray.includes(stop.propertyId)
        ) {
          propertyArray.push(stop.propertyId)
        }
      })
    }
  })
  return propertyArray
}

/**
 * Returns all distinct properties ids present in any of the client routes
 * @param {Array} clientRoutes routes for client
 */
export const propertyIdsInRoute = (clientRoutes, showPast = false) => {
  let propertyIds = []
  let routeStates = []
  clientRoutes.forEach(route => {
    if (route.routeStops) {
      route.routeStops.forEach(stop => {
        const isPast = isPastTime(route.startTime)
        const displayActive = !isPast && !showPast
        if (!propertyIds.includes(stop.propertyId) && displayActive) {
          propertyIds.push(stop.propertyId)
          routeStates.push({
            _id: stop.propertyId,
            routeState: route.state
          })
        }
      })
    }
  })
  return { propertyIds, routeStates }
}

export const propertiesIdInRoute = routeData => {
  let propertyArray = []
  routeData.routeStops.forEach(stop => propertyArray.push(stop.propertyId))
  return propertyArray
}

export const clientRoutesByState = (clientData, routeState) => {
  return clientData.routes.filter(route => route.state === routeState)
}

/**
 *
 * @param {Array} clientRoutes list of routes
 * @param {String} routeState state of route required
 */
export const propertyInRouteByStates = (
  clientRoutes,
  routeState,
  showPast = false,
  withTime = false
) => {
  let propertyIds = []
  let viewedTimes = []
  if (clientRoutes) {
    clientRoutes.forEach(route => {
      if (routeState.includes(route.state)) {
        if (showPast) {
          if (isPastTime(route.startTime)) {
            route.routeStops.forEach(stop => {
              if (!propertyIds.includes(stop.propertyId) && stop.arrivalTime) {
                propertyIds.push(stop.propertyId)
                viewedTimes.push({
                  _id: stop.propertyId,
                  viewedTime: stop.arrivalTime
                })
              }
            })
          }
        } else {
          if (!isPastTime(route.startTime)) {
            route.routeStops.forEach(stop => {
              if (!propertyIds.includes(stop.propertyId)) {
                propertyIds.push(stop.propertyId)
              }
            })
          }
        }
      }
    })
  }
  if (withTime) {
    return { propertyIds, viewedTimes }
  }
  return propertyIds
}

export const getRouteIdsArray = routeList => {
  return routeList.map(route => route._id)
}

export const getRouteMessagesIdArray = messagesList => {
  return messagesList.map(
    msg =>
      msg.metadata && msg.metadata.data && msg.metadata.data.thread.route_id
  )
}

export const isSendReminderActive = route => {
  if (!isEmpty(route.scheduleShared)) {
    const scheduleTimestamps = route.scheduleShared
    const lastScheduleTimestamp =
      scheduleTimestamps[scheduleTimestamps.length - 1]
    const currentTime = moment.utc().format()
    const duration = moment.duration(
      moment(currentTime).diff(moment(lastScheduleTimestamp))
    )
    return duration.asHours() < 24
  }
  return false
}

export const pastScheduledProperties = (clientRoutes, withTime = false) => {
  let propertyIds = []
  let viewedTimes = []
  clientRoutes.forEach(route => {
    if (
      (isPastTime(route.startTime) ||
        moment(route.startTime).isSame(moment(), 'day')) &&
      route.state === 'scheduled'
    ) {
      route.routeStops.forEach(stop => {
        if (!propertyIds.includes(stop.propertyId) && stop.arrivalTime) {
          propertyIds.push(stop.propertyId)
          viewedTimes.push({
            _id: stop.propertyId,
            viewedTime: stop.arrivalTime
          })
        }
      })
    }
  })
  if (withTime) {
    return { propertyIds, viewedTimes }
  }
  return propertyIds
}

export const filterRouteByDate = (routeException, routeData, date) => {
  const dayRoutes = routeData.filter(route => {
    if (!isEmpty(routeException)) {
      return (
        moment(route.startTime).isSame(date, 'day') &&
        routeException._id !== route._id
      )
    }
    return moment(route.startTime).isSame(date, 'day')
  })

  let routeTimes = []
  if (dayRoutes.length > 0) {
    dayRoutes.map((route, index) => {
      let timeObject = {
        start: getStartTime(route.startTime),
        end: getEndTime(route)
      }
      routeTimes.splice(index, 1, timeObject)
    })
  }
  return routeTimes
}

const getStartTime = date => {
  return moment(date)
    .subtract(30, 'minutes')
    .format('HH:mm')
}

const getEndTime = route => {
  if (route.routeStops && totalActiveRouteStops(route.routeStops) > 1) {
    let lastPoint = null
    for (let i = route.routeStops.length - 1; i >= 0; i--) {
      if (route.routeStops[i].arrivalTime) {
        lastPoint = route.routeStops[i]
        break
      }
    }
    if (lastPoint) {
      return moment(lastPoint.arrivalTime)
        .add(15, 'minutes')
        .format('HH:mm')
    }
  }
  return moment(route.startTime)
    .add(105, 'minutes')
    .format('HH:mm')
}

export const isTimePresent = (timeSpans, timeToCheck) => {
  let blockTime = false
  if (timeSpans.length > 0) {
    timeSpans.forEach(span => {
      const startTime = moment(span.start, timeFormat).subtract(
        timeMargin,
        'minutes'
      )
      const endTime = moment(span.end, timeFormat).add(timeMargin, 'minutes')
      if (
        moment(timeToCheck, timeFormat).isBetween(
          moment(startTime, timeFormat),
          moment(endTime, timeFormat)
        )
      ) {
        blockTime = true
      }
    })
  }
  return blockTime
}

export const getAvailableTime = timeSpans => {
  if (timeSpans.length > 0) {
    let sortedTimeSpans = sortObjectArrayByKey(timeSpans, 'start')
    let availableTime = moment(sortedTimeSpans[0].end, timeFormat).add(
      timeMargin,
      'minutes'
    )
    return moment(availableTime).format(timeFormat)
  }
}

export const isTodayOrFuture = date => {
  return (
    moment(date).isSame(moment(), 'day') ||
    moment(date).isAfter(moment(), 'days') > 0
  )
}

export const isCustomStartInRoute = routeData => {
  return (
    routeData.customStartLocation && routeData.customStartLocation === true
  )
}

export const isCustomEndInRoute = routeData => {
  return routeData.customEndLocation && routeData.customEndLocation === true
}

export const isDeclinedRoute = routeData => {
  return (
    routeData &&
    routeData.routeStops &&
    routeData.routeStops.filter(stop => stop.state === 'decline').length ===
      routeData.routeStops.length
  )
}

export const isNotScheduledType = routeData => {
  return (
    routeData &&
    routeData.routeStops &&
    routeData.routeStops.filter(stop => stop.arrivalTime !== null).length === 0
  )
}

export const isPastRoute = route => {
  return !isEmpty(route) && isPastTime(route.startTime)
}

export const isPastTime = date => {
  return (
    date <
    moment()
      .utc()
      .format()
  )
}

export const displayRoute = (route, profileStatus) => {
  if (route.state === 'cancelled') return false
  if (
    moment(route.startTime).isBefore(moment().format('YYYY-MM-DD')) &&
    route.state !== 'scheduled'
  ) {
    return false
  }
  if (profileStatus === 'client' && route.state !== 'scheduled') {
    return false
  }
  if (isDeclinedRoute(route) || isNotScheduledType(route)) return false
  return true
}

export const hideDirectionButton = (route, markerState) => {
  return isDeclinedRoute(route) || isNotScheduledType(route) || markerState
}

/**
 * Redirects to google map page with route display based on calculated markers
 * @param {Array} calculatedRouteHomes - calculated marker locations
 */

export const displayRouteDirections = async calculatedRouteHomes => {
  const google = await googleMapInit()
  const geocoder = new google.maps.Geocoder()
  const calculatedStops = [...calculatedRouteHomes]
  const lastIndex = calculatedStops.length - 1
  const destination = encodeURI(getEndLocationAddressText(await codeAddress(geocoder, calculatedStops[lastIndex].Address)))
  let waypoints = ''
  if (calculatedStops.length > 1) {
    for (let i = 0; i < calculatedStops.length - 1; i++) {
      const waypointStop = calculatedStops[i]
      waypoints += encodeURI(getStartLocationAddressText(await codeAddress(geocoder, waypointStop.Address)))
      if (i < calculatedStops.length - 2) {
        waypoints += '|'
      }
    }
  }
  const routeLink = `https://www.google.com/maps/dir/?api=1&mode=driving&destination=${destination}${
    waypoints ? '&waypoints=' + waypoints : ''
  }`

  window.open(routeLink, '_blank')
}
export const codeAddress = (geocoder, address) => {
  return new Promise((resolve, reject) => {
    geocoder.geocode({ 'address': address }, (res) => {
      resolve(res[0].formatted_address)
    })
  })
}

export const isActiveRouteStop = stop => {
  return (
    stop.state !== 'decline' &&
    stop.state !== 'notscheduled' &&
    stop.state !== 'cancelled'
  )
}

export const totalActiveRouteStops = routeStops => {
  return routeStops.filter(stop => isActiveRouteStop(stop)).length
}

export const getStartLocationAddressText = location => {
  return location.includes('Custom Start Location')
    ? location.substr(location.indexOf(':') + 1)
    : location
}

export const getEndLocationAddressText = location => {
  return location.includes('Custom End Location')
    ? location.substr(location.indexOf(':') + 1)
    : location
}

export const isConfirmedOrScheduledRoute = route => {
  return route.state === 'confirmed' || route.state === 'scheduled'
}

export const isCancelledRoute = route => route.state === 'cancelled'
